import { render, staticRenderFns } from "./ChooseBundleOptionsModal.vue?vue&type=template&id=563c5ea2&scoped=true"
import script from "./ChooseBundleOptionsModal.vue?vue&type=script&lang=js"
export * from "./ChooseBundleOptionsModal.vue?vue&type=script&lang=js"
import style0 from "./ChooseBundleOptionsModal.vue?vue&type=style&index=0&id=563c5ea2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563c5ea2",
  null
  
)

export default component.exports